import { takeLatest, put, call, select } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { updateProgram } from './helpers'
import getData from '../../functions/getData'
import { PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_MOVIEMAPPING_ITEMS } from '../../constants/state'
// import ItemsPerCinema from '../../components/PageEditSelection/ItemsPerCinema'

const pmMoviePkSelector = (state, pmMoviePk) => getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, pmMoviePk, 'pm'])
const pmCliMovieSelector = (state, pmMoviePk) => getData(state, [PROGRAM_CLI_MOVIES_ITEMS, pmMoviePk])



function* putMovie(type, pk, itemData, updateLocal) {
    yield put({
        type: type, 
            payload: {
            pk: pk,
            itemData: itemData
        }
    })
}

function* putMetaOrigin(type, pk, dataMeta) {
    yield put({
        type: type,
        payload: {
            pk: pk,
            dataMeta: dataMeta
        }
    })
}

function* sanitizeImages(pk, newMovieData) {
    const oldData = yield select(pmCliMovieSelector, pk)
    const oldMovieData = yield oldData.toJS()

    if(newMovieData.images.poster !== null && newMovieData.images.poster.id === null) {
        newMovieData.images.poster = yield null
    }

    if(
        (newMovieData.images.ambient !== null && newMovieData.images.ambient.id === null) &&
        (oldMovieData.images.ambient !== null && _.isEqual(newMovieData.images.ambient, oldMovieData.images.ambient))
    ) {
        newMovieData.images.ambient = yield null
    }

    if(newMovieData.images.backgrounds && oldMovieData.images.backgrounds && newMovieData.images.backgrounds.length === oldMovieData.images.backgrounds.length) {
        const sanBackgrounds = []
        let hasChanges = false

        newMovieData.images.backgrounds.map((item, index) => {
            if(!hasChanges && !_.isEqual(item, oldMovieData.images.backgrounds[index])) {
                hasChanges = true
            }
            
            if(!hasChanges && item.id !== null) {
                sanBackgrounds.push(item)
            }
        })

        if(!hasChanges) {
            newMovieData.images.backgrounds = sanBackgrounds
        }
    }

    return yield newMovieData
}

function* updateMovie({payload}) {
    const { pk, dataMovie, dataMeta, dataAttributes, updateLocal } = yield payload
    const pmMoviePk = yield select(pmMoviePkSelector, pk)
    const sanDataMovie = yield updateLocal ? yield dataMovie : yield call(sanitizeImages, pk, dataMovie)
    // const sanDataMovie = yield call(sanitizeImages, pk, dataMovie)
    
    yield call(putMovie, actionTypes.PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES, pmMoviePk, sanDataMovie, updateLocal)
    yield call(putMetaOrigin, actionTypes.METAMOVIES_UPDATE_ITEM_ORIGIN, pk, dataMeta)
    yield call(putMovie, actionTypes.CLIMOVIES_UPDATE_ITEM, pk, sanDataMovie, updateLocal)
    yield put({
        type: actionTypes.ATTRIBUTES_UPDATE,
        payload: {
            dataAttributes: dataAttributes
        }
    })


    if(!updateLocal) {
        yield call(updateProgram)
    }
}

export function* watchUpdateMovieItem() {
    try {
        yield takeLatest(actionTypes.MOVIES_UPDATE_ITEM_REQUEST, updateMovie)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}